var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1616 0.0885833C12.4434 0.209194 12.6063 0.506874 12.5559 0.809288L11.285 8.43496H17.5C17.7518 8.43496 17.9821 8.57727 18.0948 8.80257C18.2074 9.02786 18.1831 9.29746 18.032 9.49896L9.63196 20.699C9.44801 20.9442 9.12022 21.032 8.83835 20.9113C8.55649 20.7907 8.39361 20.493 8.44401 20.1906L9.71496 12.565H3.49996C3.24808 12.565 3.01782 12.4227 2.90517 12.1974C2.79253 11.9721 2.81683 11.7025 2.96796 11.501L11.368 0.300963C11.5519 0.0556941 11.8797 -0.0320272 12.1616 0.0885833ZM4.82996 11.235H10.5C10.6954 11.235 10.881 11.321 11.0074 11.4701C11.1337 11.6193 11.1881 11.8165 11.1559 12.0093L10.2043 17.7192L16.17 9.76496H10.5C10.3045 9.76496 10.1189 9.67896 9.99256 9.5298C9.8662 9.38065 9.81188 9.18346 9.84401 8.99064L10.7957 3.28069L4.82996 11.235Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBolt);
export default __webpack_public_path__ + "static/media/LightningBolt.b4607883fc519343dbc9158eaf0ab018.svg";
export { ForwardRef as ReactComponent };